import { render, staticRenderFns } from "./InlineEditorTopbarIndicator.vue?vue&type=template&id=dd04a476&"
import script from "./InlineEditorTopbarIndicator.vue?vue&type=script&lang=ts&"
export * from "./InlineEditorTopbarIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./InlineEditorTopbarIndicator.vue?vue&type=style&index=0&id=dd04a476&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports